module.exports = __webpack_public_path__ + "static/img/iso.df031b0b.png";